import { Reveal } from "./Reveal";
import { IMAGES } from "../constants/contact";

const CARD_IMAGES = {
  achiga: IMAGES.achiga,
  "lucio-perca": IMAGES.lucioPerca,
  "lucio-real": IMAGES.lucioReal,
  barbo: IMAGES.barbo,
};

const SPANS = {
  achiga: "lg:col-span-4",
  "lucio-perca": "lg:col-span-2 lg:mt-16",
  "lucio-real": "lg:col-span-2 lg:-mt-8",
  barbo: "lg:col-span-4",
};

export const Species = ({ t }) => (
  <section id="especies" className="relative border-t border-white/5 bg-card/40" data-testid="species-section">
    <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-40">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-gold" data-testid="species-chapter">
              {t.species.chapter}
            </p>
            <h2 className="mt-4 font-display text-4xl tracking-tight text-bone sm:text-5xl" data-testid="species-title">
              {t.species.title}
            </h2>
            <div className="mt-6 h-px w-16 bg-gold" />
          </Reveal>
        </div>
        <div className="lg:col-span-7">
          <Reveal delay={0.1}>
            <p className="font-display text-2xl italic leading-snug text-bone sm:text-3xl" data-testid="species-heading">
              {t.species.heading}
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-bone/60" data-testid="species-sub">
              {t.species.sub}
            </p>
          </Reveal>
        </div>
      </div>

      <div className="mt-20 grid gap-6 md:grid-cols-2 lg:grid-cols-6" data-testid="species-grid">
        {t.species.items.map((fish, i) => (
          <Reveal key={fish.id} delay={0.08 * i} className={`${SPANS[fish.id]} md:col-span-1`}>
            <article
              className="group overflow-hidden rounded-sm border border-white/10 bg-card transition-colors duration-500 hover:border-gold/40"
              data-testid={`species-card-${fish.id}`}
            >
              <div className="relative h-64 overflow-hidden sm:h-72">
                <img
                  src={CARD_IMAGES[fish.id]}
                  alt={fish.name}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  data-testid={`species-image-${fish.id}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-card via-transparent to-transparent" />
              </div>
              <div className="p-7">
                <h3 className="font-display text-3xl tracking-tight text-bone" data-testid={`species-name-${fish.id}`}>
                  {fish.name}
                </h3>
                <p className="mt-1 font-mono text-[11px] italic tracking-wider text-gold/80">{fish.latin}</p>
                <p className="mt-4 text-sm leading-relaxed text-bone/60" data-testid={`species-desc-${fish.id}`}>
                  {fish.desc}
                </p>
                <p className="mt-6 border-t border-white/10 pt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-bone/40">
                  <span className="text-gold">{t.species.techniqueLabel}</span> — {fish.technique}
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
